import { z } from 'zod';

export const registrationStepSixSchema = z.object({
    purpose: z.enum(['love', 'fun', 'not_specified']).nullable(),
});

export type RegistrationStepSixType = z.infer<typeof registrationStepSixSchema>;
